<template>
  <b-table small responsive :items="tableData" :fields="tableColumns" no-sort-reset id="observableTable">
    <template #cell(actions)="row">
      <b-dropdown text="Sections" size="sm" variant="info" boundary="viewport">
        <b-dropdown-item :to="`/observatory/${row.item.slug}/dashboard`">Dashboard</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-group id="reports" header="Reports">
          <b-dropdown-item :to="`/observatory/${row.item.slug}/reports/ceo-summary`">CEO Summary</b-dropdown-item>
          <b-dropdown-item :to="`/observatory/${row.item.slug}/reports/agent-production`">Agent Production</b-dropdown-item>
          <b-dropdown-item :to="`/observatory/${row.item.slug}/reports/lead-gen-conversions`">Lead Gen & Conversions</b-dropdown-item>
          <b-dropdown-item :to="`/observatory/${row.item.slug}/reports/lead-sources`">Lead Sources</b-dropdown-item>
          <b-dropdown-item :to="`/observatory/${row.item.slug}/reports/financials`">Profit & Loss</b-dropdown-item>
        </b-dropdown-group>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-group id="business-information" header="Business Planning">
          <b-dropdown-item :to="`/observatory/${row.item.slug}/business-planning/business-info`">Business Information</b-dropdown-item>
          <b-dropdown-item :to="`/observatory/${row.item.slug}/business-planning/economic-model`">Economic Model</b-dropdown-item>
          <b-dropdown-item :to="`/observatory/${row.item.slug}/business-planning/budget-model`">Budget Model</b-dropdown-item>
          <b-dropdown-item :to="`/observatory/${row.item.slug}/business-planning/lead-gen-model`">Lead Gen Model</b-dropdown-item>
        </b-dropdown-group>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item :to="`/observatory/${row.item.slug}/goal-gap`">Goal/Gap</b-dropdown-item>
        <b-dropdown-item :to="`/observatory/${row.item.slug}/daily-tracking`">Daily Tracking</b-dropdown-item>
        <b-dropdown-item :to="`/observatory/${row.item.slug}/pipelines`">Pipelines</b-dropdown-item>
        <b-dropdown-item :to="`/observatory/${row.item.slug}/listings`">Listings</b-dropdown-item>
        <b-dropdown-item :to="`/observatory/${row.item.slug}/transactions`">Transactions</b-dropdown-item>
        <b-dropdown-item :to="`/observatory/${row.item.slug}/financials`">Financials</b-dropdown-item>
        <b-dropdown-divider v-if="row.item.pulse"></b-dropdown-divider>
        <b-dropdown-item :to="`/observatory/${row.item.slug}/pulse/dashboard`" v-if="row.item.pulse">Pulse Dashboard</b-dropdown-item>
      </b-dropdown>
    </template>
    <template #cell(setup_complete)="row">
      <i class="fas fa-check" v-if="row.item.setup_complete"></i>
      <i class="fas fa-times text-danger" v-else></i>
    </template>
    <template #cell(roles)="row">
      <b-badge variant="primary" v-for="(role, key) in row.item.roles" :key="key" class="mr-2">
        {{ role }}
      </b-badge>
    </template>
    <template #cell(active)="row">
      <i class="fas fa-check" v-if="row.item.active"></i>
      <i class="fas fa-times text-danger" v-else></i>
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    tableData: null,
  },
  data() {
    return {
      tableColumns: [
        {
          key: 'actions'
        },
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'email'
        },
        {
          key: 'setup_complete',
          sortable: true
        },
        {
          key: 'roles'
        },
        {
          key: 'active'
        }
      ],
    }
  }
};
</script>